class Tag {

	static fromArray(data, list) {
		let inst = new Tag(list);
		inst.id = data.shift();
		inst.name = data.shift();
		inst.color = data.shift();
		inst.orderBy = data.shift();
		return inst.init();
	}

	static blank(list) {
		let inst = new Tag(list);
		inst.name = _("New Tag");
		inst.color = null;
		inst.orderBy = list._editList.length + 1;
		return inst.init();
	}

	constructor (list) {
		this._id = 0;
		this._name = null;
		this._color = null;
		this._orderBy = null;
		this._list = list;
		
		this._chkBox = chk('alt-chk');
		onEv(this._chkBox, 'change', this.toggleSelect.bind(this));
	}

	init() {
		this._rowElem = div('list-row-wrap', [
			this._dragElem = div('list-row align-items-center editing-off norm', [
				div('col-auto drag-handle', null, {
					'mousedown touchstart': this.prepDrag.bind(this)
				}),
				div('col-auto', [
					this._nameEdit = text('edit-show'),
					this._nameView = span('tx-span edit-hide', this._name),
				]),
				div('col-auto ms-auto', [
					btn('btn edit-show', _("SAVE"), {'click': this.save.bind(this)}),
					btn('btn edit-show', _("CANCEL"), {'click': this.cancel.bind(this)}),
					btn('btn i-rg i-edit edit-hide', null, {'click': this.edit.bind(this)}),
					btn('btn i-rg i-delete edit-hide', null, {'click': this.delete.bind(this)})
				])
			])
		]);

		this._chkElem = div(null, [
			label(null, [
				this._chkBox,
				span('i-rg chk-box')
			]),
			this._nameView2 = span('tx-span edit-hide', this._name),
		]);
		return this;
	}

	get id() {return this._id;} 
	set id(v) {this._id = v;}

	get name() {return this._name;}
	set name(v) {this._name = v;}

	get color() {return this._color;}
	set color(v) {this._color = v;}

	get orderBy() {return this._orderBy;}
	set orderBy(v) {this._orderBy = v;}

	get rowElem() {return this._rowElem;}
	get dragElem() {return this._dragElem;}

	get isSet() {return this._chkBox.checked;}
	set isSet(v) {this._chkBox.checked = !!v;}

	/** These functions need to be actual functions so 
	 * 	they can be passed as reference to the OrderedList2 instance
	 */
	getOrder() {return this._orderBy;}
	getRow() {return this._rowElem;}
	getDrag() {return this._dragElem;}
	getChkRow() {return this._chkElem;}

	prime(v) {
		this._chkBox.checked = v === 1;
		this._chkBox.indeterminate = v === 2;
	}

	prepDrag(ev) {
		this._list.prepDrag(this, ev);
	}

	clicked() {}

	dropped() {
		this.orderBy = this._list._editList.getPos();
		ajg('tag/order', [
			'id=' + this.id,
			'orderBy=' + this.orderBy
		], null, reply => {
			this._list._checkList.sort();
			showError(reply)
		});
	}

	toggleSelect() {
		ajg('tag/map', [
			'id=' + this._id,
			'selectionType=' + this._list._selectionType,
			'selectionIds=' + encodeURI(this._list._selectionIds.join(',')),
			'value=' + (this._chkBox.checked ? 1 : 0)
		]);
	}

	edit() {
		if (this._list._activeTag) return;
		this._list._activeTag = this;
		this._nameEdit.value = this._name;
		Dialog.Inline(this._dragElem, this);
		this._nameEdit.select();
	}

	save() {
		if (this._nameEdit.value.length) this._name = this._nameEdit.value;
		this._nameView.innerHTML = this._nameView2.innerHTML = this._name;

		ajg('tag/save', [
			'id=' + this._id || 0,
			'name=' + encodeURI(this.name),
			'orderBy=' + this._orderBy
		], null, reply => {
			showError(reply);
			if (reply.id) this.id = reply.id;
			if (this._list._selectionIds) {
				this._chkBox.checked = true;
				this.toggleSelect();
			}
			if (this._list._activeTag) this.finish();
		}, this);
	}
	
	cancel() {
		this.finish();
		if (this._id === 0) this._list.remove(this);
	}

	finish() {
		Dialog.Inline(this._dragElem);
		this._list._activeTag = null;
	}

	delete() {
		ajg('tag/delete', [
			'id=' + this.id
		], null, reply => {
			if (showError(reply)) return;
			this._list.remove(this);
		}, this);
	}
}